const WORK = 'work';
const RECOUPED_WORK = 'recouped-work';
const WEEKLY_REST = 'weekly-rest';
const MEDICAL_REST = 'medical-rest';
const ABSENCE = 'absence';
const VACATION = 'vacation';
const MEDICAL_LEAVE = 'medical-leave';
const EXEMPTION = 'exemption';

const types = {
  WORK,
  RECOUPED_WORK,
  WEEKLY_REST,
  MEDICAL_REST,
  ABSENCE,
  VACATION,
  MEDICAL_LEAVE,
  EXEMPTION,
};

const humanizedNames = {
  [WORK]: 'Trabalho',
  [RECOUPED_WORK]: 'Trabalho em Compensação',
  [WEEKLY_REST]: 'Folga',
  [ABSENCE]: 'Falta',
  [EXEMPTION]: 'Diária',
  [MEDICAL_LEAVE]: 'Afastamento',
  [MEDICAL_REST]: 'Atestado Médico',
  [VACATION]: 'Férias',
};

export { types, humanizedNames };
export default types;



// WEBPACK FOOTER //
// ./src/Driver/lifeEvents.types.js